function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import LogoText from './LogoText';
import Panel from './Panel';
import styles from './Notice.module.scss';
import CenteredLayout from './layouts/CenteredLayout';
import { Divider, Text, Title } from '@mantine/core';
function Notice(_param) {
    var beforeElement = _param.beforeElement, afterElement = _param.afterElement, buttons = _param.buttons, heading = _param.heading, description = _param.description, props = _object_without_properties(_param, [
        "beforeElement",
        "afterElement",
        "buttons",
        "heading",
        "description"
    ]);
    return /*#__PURE__*/ _jsx(CenteredLayout, {
        children: /*#__PURE__*/ _jsxs(Panel, _object_spread_props(_object_spread({
            className: styles.panel
        }, props), {
            children: [
                /*#__PURE__*/ _jsx(LogoText, {
                    className: styles.logo
                }),
                /*#__PURE__*/ _jsx(Divider, {
                    className: styles.divider
                }),
                beforeElement != null ? /*#__PURE__*/ _jsx("div", {
                    className: styles.beforeElement,
                    children: beforeElement
                }) : null,
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.header,
                    children: [
                        heading != null ? /*#__PURE__*/ _jsx(Title, {
                            order: 3,
                            children: heading
                        }) : null,
                        /*#__PURE__*/ _jsx(Text, {
                            size: "sm",
                            c: "dimmed",
                            children: description
                        })
                    ]
                }),
                afterElement != null ? /*#__PURE__*/ _jsx("div", {
                    className: styles.afterElement,
                    children: afterElement
                }) : null,
                buttons != null ? /*#__PURE__*/ _jsx("div", {
                    className: styles.buttons,
                    children: buttons
                }) : null
            ]
        }))
    });
}
export default Notice;
